// Onboarding wizard data sources - single source of truth for option lists.

export const US_STATES = [
  'Alabama','Alaska','Arizona','Arkansas','California','Colorado','Connecticut',
  'Delaware','District of Columbia','Florida','Georgia','Hawaii','Idaho','Illinois',
  'Indiana','Iowa','Kansas','Kentucky','Louisiana','Maine','Maryland','Massachusetts',
  'Michigan','Minnesota','Mississippi','Missouri','Montana','Nebraska','Nevada',
  'New Hampshire','New Jersey','New Mexico','New York','North Carolina','North Dakota',
  'Ohio','Oklahoma','Oregon','Pennsylvania','Puerto Rico','Rhode Island','South Carolina',
  'South Dakota','Tennessee','Texas','Utah','Vermont','Virginia','Washington',
  'West Virginia','Wisconsin','Wyoming',
];

export const CITIZENSHIP = ['US Citizen','US Permanent Resident','Other'];

export const TIMELINES = [
  'Already there','Within 3 months','3-6 months','6-12 months','1-2 years','Just exploring',
];

export const LIFESTYLE = [
  'Beach','City Life','Colonial Town','Quiet/Rural','Digital Nomad Hub','Best Value',
];

export const MX_DESTINATIONS = [
  'Mexico City (CDMX)','Mérida, Yucatán','Playa del Carmen, Quintana Roo','Tulum, Quintana Roo',
  'Puerto Vallarta, Jalisco','San Miguel de Allende, Guanajuato','Guadalajara, Jalisco',
  'Monterrey, Nuevo León','Oaxaca City, Oaxaca','Querétaro, Querétaro','Puebla, Puebla',
  'Cancún, Quintana Roo','Cozumel, Quintana Roo','Bacalar, Quintana Roo','Mazatlán, Sinaloa',
  'San Cristóbal de las Casas, Chiapas','Cabo San Lucas, Baja California Sur',
  'La Paz, Baja California Sur','Todos Santos, Baja California Sur','Ensenada, Baja California',
  'Tijuana, Baja California','Sayulita, Nayarit','San Pancho, Nayarit','Bucerías, Nayarit',
  'Riviera Nayarit','Valle de Bravo, Estado de México','Cuernavaca, Morelos','Tepoztlán, Morelos',
  'Guanajuato City, Guanajuato','Morelia, Michoacán','León, Guanajuato','Aguascalientes',
  'Veracruz','Holbox, Quintana Roo','Isla Mujeres, Quintana Roo','Tapalpa, Jalisco',
];

export const MOVE_TYPES = ['Solo','Couple','Family with children','Retiring'];
export const CHILDREN_COUNTS = ['1','2','3','4+'];
export const VEHICLE_PLATES = ['US plates','Mexican plates'];
export const VEHICLE_TYPES = ['Car','Truck','Motorcycle','RV/Camper'];
export const BUDGETS = [
  'Under $1,500','$1,500-$2,500','$2,500-$4,000','$4,000-$6,000','$6,000+',
];

export const VISA_GOAL = [
  'Just visiting (tourist/FMM)','Temporary Resident','Permanent Resident',
  'Already have residency','Not sure',
];
export const REMOTE_WORK = ['Yes','No',"I'm retired"];
export const RFC = ['Yes','No',"What's that?"];
export const PROPERTY = ['Yes','No','Maybe later'];

export const PRIORITIES = [
  'Cost of living','Safety','Expat community','Healthcare quality','Nightlife & culture',
  'Nature & outdoors','Good internet/coworking','Proximity to US border','Schools for kids','Pet-friendly',
];
export const MEXICO_VISITS = [
  'Never','Once or twice','Several times',"I've lived there",
];
